import { Dialog, Transition } from "@headlessui/react";
import { Fragment, useState } from "react";
import { formatCheckinDate } from "../../../utils/util";
import { request_lost_tem } from "../../../actions/lostItem/lostItemReq";
import { LostItemSubmitButtonClick } from "../../../utils/Analytics";

export default function LostItemModal(props) {
  const { data } = props;
  const[errorMsg, setResponseMsg] =  useState("")

  let [isOpen, setIsOpen] = useState(true);
  const [formObj, setFormObj] = useState({
    comments: "",
    bookingObj: {
      reservationId: data[0]?.reservationId,
      hotelId: data[0]?.hotelId,
    },
  });

  const handleForm = (data, type) => {
    console.log(data)
    switch (type) {
      case "bookingObj":
        setFormObj((prevFormObj) => ({
          ...prevFormObj,
          bookingObj: data,
        }));

        break;
      case "comments":
        setFormObj((prevFormObj) => ({
          ...prevFormObj,
          comments: data,
        }));

        break;

      default:
        break;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    LostItemSubmitButtonClick();
    if (!formObj.comments.trim()) {
      setResponseMsg("Details cannot be empty");
      return; // Prevent form submission
    }
    try{
      const res = await request_lost_tem(formObj);
      console.log(res)
      if(res?.data?.success){
        setResponseMsg("Successfully Requested")
        setTimeout(() => {
          props.hide()
        }, 2500);
      }else{
        console.log("object")
        setResponseMsg("something went wrong")
      }
    }catch(e){
      console.log(e)
      setResponseMsg("something went wrong")
    }
    
  };

  return (
    <Transition appear show={true} as={Fragment}>
      <Dialog as="div" className="relative z-10" onClose={props.hide}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black/25" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl black-bg-modal p-6 text-left align-middle shadow-xl transition-all">
                <Dialog.Title as="h3" className="text-lg font-medium leading-6">
                  Request Lost Item
                </Dialog.Title>
                <form action="" onSubmit={handleSubmit}>
                <div className="mt-6 text-sm text-gray-500 flex flex-col gap-3">
                  <div>
                    <label htmlFor="">Select Booking</label>
                    <select
                      onChange={(e) => handleForm(JSON.parse(e.target.value), "bookingObj")}
                      className="reqInput mt-2"
                      name=""
                      id=""
                    >
                      {data.map((item, i) => (
                        <option value={JSON.stringify({
                            reservationId: item?.reservationId,
                            hotelId: item?.hotelId
                          })} key={i}>
                          <span>{item.restaurantName}, Check-in Date - </span>
                          <br />
                          {formatCheckinDate(item?.dateIn)}{" "}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div>
                    <label htmlFor="">Details</label>
                    <textarea
                      onChange={(e) => handleForm(e.target.value, "comments")}
                      value={formObj?.comments}
                      className="reqInput mt-2"
                      type="text"
                    />
                  </div>
                  {/* <div>
                    <label htmlFor="">mobile number</label>
                    <input placeholder="Eg. 7894561230" className="mt-2 px-2" type="text" />
                  </div> */}
                </div>
                <div className="mt-4">
                  <button
                    type="submit"
                    className="upload-btn w-full"
                   >
                    Submit
                  </button>
                </div>
                </form>
                <div className={errorMsg === "Successfully Requested"? "text-green-500 text-center mt-3": "text-red-500 text-center mt-3"}>{errorMsg}</div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
}
